module.exports = __webpack_public_path__ + "static/media/burger-menu-blue.4120278c.svg";